import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import SettingsButton from './SettingsButton';
import media from '../style/media';
import { Flex } from './shared/Flex';

const Wrapper = styled(Flex)`
  width: 100%;
  // position: absolute;
  justify-content: flex-end;
  padding: 20px;
  align-items: center;
  z-index: 2;
`;

const TopBar = ({ onSettingsClick, isMeasuring }) => {
  return (
    <Wrapper>
      {/* <Logo /> */}
      <SettingsButton disable={isMeasuring} onClick={onSettingsClick} />
    </Wrapper>
  );
};

export default TopBar;
